import { flow } from 'lodash';
import { IndividualFolioRequestType } from '../types';

const groupObjectArray =
    <T extends string & keyof K, K extends { [key: string]: T }>(objectArray: K[]) =>
        (accumalateKey: T) => {
            const objectReducer = (acc: Record<K[T], K[]>, curr: K) => {
                const currentKey = curr[accumalateKey];
                if (acc[currentKey]) {
                    acc[currentKey].push(curr);
                } else {
                    acc[currentKey] = [curr];
                }
                return acc;
            };
            return objectArray.reduce(objectReducer, {} as Record<K[T], K[]>);
        };

export enum RequestStatus {
    Pending = 'pending',
    NoDataFound = 'nodatafound',
    Failure = 'failure',
    Completed = 'completed',
}

export const RequestStatusLabelMap = {
    [RequestStatus.Pending]: 'Pending',
    [RequestStatus.Failure]: 'Failure',
    [RequestStatus.NoDataFound]: 'No Data Found',
    [RequestStatus.Completed]: 'Completed',
};

const joinRequestIdData = (
    summaryData: IndividualFolioRequestType[],
): IndividualFolioRequestType[] => {
    const reqIdGroupedData = groupObjectArray(summaryData)('reqId');
    return Object.keys(reqIdGroupedData).reduce((acc, curr) => {
        const currentReqData = reqIdGroupedData[curr];
        if (currentReqData.length === 1) return [...acc, currentReqData[0]];
        if (
            currentReqData[0].status === RequestStatus.NoDataFound ||
            currentReqData[0].status === RequestStatus.Failure
        )
            return [...acc, currentReqData[1]];
        if (
            currentReqData[1].status === RequestStatus.NoDataFound ||
            currentReqData[1].status === RequestStatus.Failure
        )
            return [...acc, currentReqData[0]];
        const mergedData = {
            ...currentReqData[0],
            data: [...currentReqData[0].data, ...currentReqData[1].data]
        }
        return [...acc, mergedData];
    }, [] as IndividualFolioRequestType[]);
};

const parseRequestSummary = (
    requestSummary: IndividualFolioRequestType[],
): IndividualFolioRequestType[] => {
    const SPACE = ' ';
    const NONE = '';
    return requestSummary.map((request) => {
        return {
            ...request,
            status: request.status.replaceAll(SPACE, NONE).toLowerCase() as RequestStatus,
        };
    });
};
export const parseInactiveFoliosData = flow(parseRequestSummary, joinRequestIdData);
